<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: meta.links.activities_index,
                    },
                    {
                        name: $t('messages.practice'),
                        href: meta.links.practice_index,
                    },
                    {
                        name: $t('messages.results_per_tag'),
                        href: null,
                    },
                ]"
            />
        </template>

        <EmptyState v-if="subjects.length === 0" picture />
        <div v-else class="flex flex-wrap gap-x-2">
            <AppButton
                element="InertiaLink"
                :href="subject.url"
                v-for="subject in subjects"
                :key="subject.id"
                class="flex gap-x-2"
            >
                {{ subject.text }}

                <IconCircleCheckFilled class="h-5 w-5 text-indigo-600" v-if="filters.subject_id == subject.id" />
            </AppButton>
        </div>

        <form :action="meta.links.index" method="GET" @submit.prevent="filter" v-if="filters.subject_id">
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 md:grid-cols-12">
                <div class="sm:col-span-2">
                    <div class="mt-1" v-if="options.contentBlocks.length">
                        <FormLabel :value="$tc('messages.content_blocks', 1)" for="content_block_id" />
                        <FormSelect
                            id="subject_id"
                            v-model="form.content_block_id"
                            :options="options.contentBlocks"
                            class="mt-1 w-full"
                        />
                        <FormError :value="form.errors.content_block_id" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.activity_mode')" for="mode" />
                        <FormSelect
                            required
                            id="mode"
                            v-model="form.mode"
                            :options="options.modes"
                            class="mt-1 w-full"
                            :null-option-text="$t('messages.all')"
                        />
                        <FormError :value="form.errors.mode" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <div class="mt-1">
                        <FormLabel :value="$tc('messages.levels', 1)" for="level_reached" />
                        <FormSelect
                            required
                            id="mode"
                            v-model="form.level_reached"
                            :options="options.level_reached"
                            class="mt-1 w-full"
                            :null-option-text="$t('messages.level_attempted')"
                        />
                        <FormError :value="form.errors.mode" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.date_from')" for="date_from" />
                        <FormInput id="date_from" v-model="form.date_from" type="date" name="date_from" class="mt-1" />
                        <FormError :value="form.errors.date_from" class="mt-2" />
                    </div>
                </div>

                <div class="sm:col-span-2">
                    <div class="mt-1">
                        <FormLabel :value="$t('messages.date_to')" for="date_to" />
                        <FormInput id="date_to" v-model="form.date_to" type="date" name="date_to" class="mt-1" />
                        <FormError :value="form.errors.date_to" class="mt-2" />
                    </div>
                </div>
            </div>
        </form>

        <div v-if="graph">
            <div>
                <apexchart
                    :type="graph.chart.type"
                    :height="graph.chart.height"
                    :series="graph.series"
                    :options="graph"
                />
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppButton from '@/components/AppButton.vue';
import { IconCircleCheckFilled } from '@tabler/icons-vue';
import EmptyState from '@/components/EmptyState.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';

export default {
    components: {
        FormInput,
        FormLabel,
        FormError,
        FormSelect,
        EmptyState,
        IconCircleCheckFilled,
        PanelPage,
        AppButton,
    },
    layout: Layout,
    name: 'Index',
    props: ['subjects', 'graph', 'group', 'filters', 'options', 'meta'],
    data() {
        return {
            form: this.$inertia.form({
                subject_id: this.filters.subject_id,
                content_block_id: this.filters.content_block_id,
                mode: this.filters.mode,
                date_from: this.filters.date_from,
                date_to: this.filters.date_to,
                level_reached: this.filters.level_reached,
            }),
        };
    },
    watch: {
        'form.content_block_id': function () {
            this.filter();
        },
        'form.mode': function () {
            this.filter();
        },
        'form.date_from': function () {
            this.filter();
        },
        'form.date_to': function () {
            this.filter();
        },
        'form.level_reached': function () {
            this.filter();
        },
    },
    methods: {
        filter() {
            this.form.get(this.meta.links.index);
        },
    },
};
</script>
